import axios from 'axios'
import Swiper, { Autoplay, EffectFade, Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.css'
import UAParser from 'ua-parser-js'
import { v4 as uuidv4 } from 'uuid'
import store from '../../store'
import { qs, qsa } from '../../utils'
import { getCookie, setCookie } from '../../utils/cookie'
import DefaultRenderer from './Default'

Swiper.use([Navigation, Pagination, EffectFade, Autoplay])

class PartnershipRenderer extends DefaultRenderer {
  constructor(opts) {
    super(opts)
  }

  loadCaptcha() {
    var existingScript = document.getElementById('lazy-recaptcha')

    if (!existingScript) {
      var head = document.getElementsByTagName('head')[0]
      var script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = 'https://www.google.com/recaptcha/api.js'
      script.id = 'lazy-recaptcha'
      script.class = 'g-recaptcha'

      head.appendChild(script)
    }
  }

  initRender() {
    store.resizeFn = null
    store.section = 'partnership'

    this.onPageChange()
    this.loadCaptcha()
    this.slideQuote()
    this.mountMobilePartnerLogoCarousels()

    var objThis = this
    qsa('.faq-row').forEach((element) => {
      element.addEventListener('click', function () {
        if (!this.classList.contains('active')) {
          $('.faq-row').removeClass('active')
          $('.faq-row').attr('aria-expanded', 'false')
          $('.faq-row div').slideUp()
          this.classList.add('active')
          $(this).attr('aria-expanded', 'true')
          // $(this+' p').slideToggle();
          $(this)
            .find('div')
            .slideToggle(400, () => {
              objThis.scroll.update()
              objThis.scrollTo({ target: element, offset: -200 })
            })
        } else {
          $(this).attr('aria-expanded', 'false')
          this.classList.remove('active')
          $(this)
            .find('div')
            .slideUp(400, () => {
              objThis.scroll.update()
              objThis.scrollTo({ target: element, offset: -200 })
            })
        }
      })
    })

    qsa('.weirdDropDown').forEach((element) => {
      element.addEventListener('click', function () {
        if (!this.classList.contains('active')) {
          $('.weirdDropDown').removeClass('active')
          $('.weirdDropDown').attr('aria-expanded', 'false')
          $('.weird').hide()
          this.classList.add('active')
          $(this).attr('aria-expanded', 'true')
          // $(this+' p').slideToggle();
          var weirdID = $(this).attr('id')
          $('.' + weirdID).fadeIn(400, () => {
            objThis.scroll.update()
            objThis.scrollTo({ target: element, offset: -200 })
          })
        } else {
          $(this).attr('aria-expanded', 'false')
          this.classList.remove('active')
          var weirdID = $(this).attr('id')
          $('.' + weirdID).fadeOut(400, () => {
            objThis.scroll.update()
            objThis.scrollTo({ target: element, offset: -200 })
          })
        }
      })
    })

    this.setUpVideo()
  }

  mountMobilePartnerLogoCarousels() {
    new Swiper(qs('[data-js=mobile-partner-logo-carousels]'), {
      speed: 400,
      autoplay: {
        delay: 1000,
      },
      loop: true,
      centeredSlides: true,
      slidesPerView: 1,
    })
  }

  setUpVideo() {
    const $parent = qsa('.video-mask')

    $parent.forEach(($mask) => {
      const $iframe = qs('iframe', $mask)
      const $trigger = qs('img', $mask)
      $trigger.addEventListener('click', () => {
        $iframe.src += '?autoplay=1'
        $mask.classList.add('active')
      })
      const $svg = qs('.play', $mask)
      $svg.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
          $trigger.click()
        }
      })
    })
  }

  setDropDownMenuButtons() {
    var swiper = new Swiper('.weirdDropDownList', {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 30,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    })
  }

  setPhone() {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')

    let autoplayObj = {
      autoplay: {
        delay: 5000,
        waitForTransition: true,
        disableOnInteraction: false,
      },
    }
    if (!mediaQuery || mediaQuery.matches) {
      autoplayObj.autoplay = false
    }
    this.phoneSlide = new Swiper(qs('.phone-desktop-slide2'), {
      slidesPerView: 1,
      centeredSlides: true,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      spaceBetween: 10,
      speed: 1000,
      autoplay: {
        delay: 5000,
        waitForTransition: true,
        disableOnInteraction: false,
      },
    })

    const options = qsa('.h-woption')
    options.forEach((o) => {
      o.addEventListener('click', () => {
        this.phoneSlide.slideTo(parseInt(o.dataset.opt.replace('opt-', '')))
        this.phoneSlide.update()
      })
    })
    this.phoneSlide.on('activeIndexChange', function () {
      options.forEach(($h) => {
        $h.classList.remove('active')
      })
      qs('.h-woption[data-opt=opt-' + this.activeIndex + ']') &&
        qs('.h-woption[data-opt=opt-' + this.activeIndex + ']').classList.add('active')
    })
  }

  onEnter() {
    super.onEnter()
    qs('.nav-download')?.classList?.add?.('partnerPage')
    qs('.download-fix')?.classList?.add?.('d-none')
    if (qs('.phone-desktop-slide')) {
      this.phoneSlide && this.phoneSlide.destroy()
      setTimeout(() => {
        this.setPhone()
      }, 1000)
    }
    this.setDropDownMenuButtons()
  }

  onLeave() {
    super.onLeave()
    qs("[data-track='Main CTA 2 - nav -sign-in']")?.classList?.remove?.('hidden')
    qs('.nav-download')?.classList?.remove?.('partnerPage')
    qs('.download-fix')?.classList?.remove?.('d-none')
  }

  onEnterCompleted() {
    super.onEnterCompleted()
    this.initRender()
  }

  onLeaveCompleted() {
    super.onLeaveCompleted()
  }

  slideQuote() {
    qsa('.partner-quote-slide').forEach((elem) => {
      var dots = qs('.partner-quote-dots', elem)
      const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')

      let autoplayObj = {
        autoplay: {
          delay: 4000,
          waitForTransition: true,
          disableOnInteraction: false,
        },
      }
      if (!mediaQuery || mediaQuery.matches) {
        autoplayObj.autoplay = false
      }

      new Swiper(elem, {
        slidesPerView: 1,
        centeredSlides: true,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        loop: true,
        speed: 1000,
        ...autoplayObj,
        pagination: {
          el: dots,
          clickable: true,
          renderBullet: function (index, className) {
            return (
              '<button class="' +
              className +
              '">' +
              '<svg class="fp-arc-loader" width="16" height="16" viewBox="0 0 16 16">' +
              '<circle class="path" cx="8" cy="8" r="5.5" fill="none" transform="rotate(-90 8 8)" stroke="#FFF"' +
              'stroke-opacity="1" stroke-width="1.5px"></circle>' +
              '<circle cx="8" cy="8" r="3" fill="transparent"></circle>' +
              '</svg></button>'
            )
          },
        },
      })
    })
  }

  // formDropdown() {
  //     qsa(".form-part-dropdown").forEach((x) => {
  //         x.addEventListener("click", () => {
  //             x.classList.toggle("form-active");
  //         });

  //         x.querySelectorAll(".js-form-dropdown-item").forEach((j) => {
  //             j.addEventListener("click", () => {
  //                 const dataAttr = j.getAttribute("data-value");
  //                 const dataAttr2 = j.getAttribute("data-enable");
  //                 const dataAttr3 = j.getAttribute("data-disable");
  //                 x.querySelector(".js-part-info-p").innerHTML = dataAttr;
  //                 x.querySelector(".js-part-info-p").setAttribute( "data-selected", dataAttr );
  //                 if (dataAttr2)
  //                     qs(`.${dataAttr2}`).classList.remove('dn');
  //                 if (dataAttr3)
  //                     qs(`.${dataAttr3}`).classList.add('dn');
  //             });
  //         });
  //     });
  //}
  isValid(form) {
    const getElementError = (id, text, form) => {
      const newElement = document.createElement('li')
      newElement.className = `error-${id}`
      const anchor = document.createElement('a')
      const f = form.id === 'projectForm' ? 'original' : 'copy'
      anchor.href = id !== 'employees' ? `#${id}-${f}` : `#numberOfEmp-${f}`
      anchor.textContent = text
      const spanError = qs(`#${id}-${f} ~ span.error`, form)
      spanError.textContent = text
      newElement.appendChild(anchor)
      return newElement
    }
    qs('#errors', form).innerHTML = ''
    let result = true
    if (!form.name.validity.valid) {
      const errorElement = getElementError('name', 'Please enter your name', form)
      qs('#errors', form).appendChild(errorElement)
      result = false
    }
    if (!form.email.validity.valid) {
      const errorElement = getElementError('email', 'Please enter your company email', form)
      qs('#errors', form).appendChild(errorElement)
      result = false
    }
    if (!form.job.validity.valid) {
      const errorElement = getElementError('job', 'Please enter your job title', form)
      qs('#errors', form).appendChild(errorElement)
      result = false
    }
    if (!form.company.validity.valid) {
      const errorElement = getElementError('company', 'Please enter your company name', form)
      qs('#errors', form).appendChild(errorElement)
      result = false
    }
    if (!form.employees.validity.valid) {
      const errorElement = getElementError(
        'employees',
        'Please enter the number of employees for your company',
        form,
      )
      qs('#errors', form).appendChild(errorElement)
      result = false
    }

    // if (!form.employees.validity.valid) {
    //     const errorElement = getElementError('employes', 'Please enter your work email');
    //     qs('#errors', form).appendChild(errorElement);
    //     result = false;
    // }

    // if (!form.phone.validity.valid) {
    //     const errorElement = getElementError('phone', 'Please enter your phone number');
    //     qs('#errors', form).appendChild(errorElement);
    //     result = false;
    // }
    if (!form.message.validity.valid) {
      const errorElement = getElementError('message', 'Please enter a message', form)
      qs('#errors', form).appendChild(errorElement)
      result = false
    }
    return result
  }
  formSubmit() {
    const formCopy = qs('#projectFormCopy')
    const itemsCopy = qsa('input', formCopy)

    itemsCopy &&
      itemsCopy.forEach(function (el) {
        el.addEventListener('input', function (ev) {
          if (el.validity.valid) {
            const spanError = qs('#' + el.id + ' ~ span.error')
            if (spanError) {
              spanError.textContent = ''
            }
            let node = document.querySelector('#projectFormCopy li.error-' + el.id)
            if (node && node.parentNode) {
              node.parentNode.removeChild(node)
            }
            const parent = document.querySelector('projectFormCopy .errors')
            if (parent && parent.childNodes.length === 0) {
              document.querySelector('#projectFormCopy .errors-list').style.display = 'none'
            }
          }
        })
      })

    const selectCopy = qs('select', formCopy)
    selectCopy.addEventListener('change', function (ev) {
      if (selectCopy.validity.valid) {
        const spanError = qs('#employees-copy ~ span.error')
        if (spanError) {
          spanError.textContent = ''
        }
        let node = document.querySelector('#projectFormCopy li.error-employees')
        if (node && node.parentNode) {
          node.parentNode.removeChild(node)
        }
        const parent = document.querySelector('#projectFormCopy .errors')
        if (parent && parent.childNodes.length === 0) {
          document.querySelector('#projectFormCopy .errors-list').style.display = 'none'
        }
      }
    })

    qs('#projectFormCopy.js-form-submit').addEventListener('submit', async (evt) => {
      evt.preventDefault()

      const successMsg = qs('#projectFormCopy .js-message-send')
      if (!this.isValid(formCopy)) {
        document.querySelector('#projectFormCopy .errors-list').style.display = 'block'
        document.querySelector('#projectFormCopy #errors').scrollIntoView()
        document.querySelector('#projectFormCopy #errors li:first-child > a').focus()
        return false
      }

      const getViewportData = () => {
        const width =
          window?.innerWidth ??
          document?.documentElement?.clientWidth ??
          document?.body?.clientWidth ??
          'unknown'

        const height =
          window?.innerHeight ??
          document?.documentElement?.clientHeight ??
          document?.body?.clientHeight ??
          'unknown'

        const orientationData = window?.screen?.orientation?.type
        let orientation = 'unknown'

        if (orientationData) {
          orientation = orientationData.split('-')[0]
        }

        if (!['landscape', 'portrait'].includes(orientation)) {
          orientation = window?.matchMedia?.('(orientation: portrait)')?.matches
            ? 'portrait'
            : window?.matchMedia?.('(orientation: landscape)')?.matches
            ? 'landscape'
            : 'unknown'
        }

        return { width, height, orientation }
      }

      const getDeviceId = () => {
        let deviceId = getCookie('deviceId')

        if (!deviceId) {
          deviceId = uuidv4()
          setCookie('deviceId', deviceId, {
            domain: 'earnin.com',
            sameSite: 'strict',
            secure: true,
            httpOnly: false,
            maxAge: 1707109200, // 400 days by default, max possible value as per https://developer.chrome.com/blog/cookie-max-age-expires/,,
          })
        }

        return deviceId
      }

      const userAgentData = new UAParser(navigator.userAgent).getResult()
      const viewportData = getViewportData()

      // How this code snippet works:
      // This logic overwrites the default behavior of `grecaptcha.ready()` to
      // ensure that it can be safely called at any time. When `grecaptcha.ready()`
      // is called before reCAPTCHA is loaded, the callback function that is passed
      // by `grecaptcha.ready()` is enqueued for execution after reCAPTCHA is
      // loaded.

      if (typeof grecaptcha === 'undefined') {
        grecaptcha = {}
      }

      grecaptcha.ready = function (cb) {
        if (typeof grecaptcha === 'undefined') {
          // window.__grecaptcha_cfg is a global variable that stores reCAPTCHA's
          // configuration. By default, any functions listed in its 'fns' property
          // are automatically executed when reCAPTCHA loads.
          const c = '___grecaptcha_cfg'
          window[c] = window[c] || {}
          ;(window[c]['fns'] = window[c]['fns'] || []).push(cb)
        } else {
          cb()
        }
      }

      grecaptcha.ready(() => {
        grecaptcha
          .execute(qs('#partnership-form-recaptcha'), {
            action: 'partnershipForm',
          })
          .then(async (token) => {
            const data = {
              name: formCopy.name.value,
              company: formCopy.company.value,
              email: formCopy.email.value,
              job: formCopy.job.value,
              phone: formCopy.phone?.value || '',
              message: formCopy.message.value,
              employees: formCopy.employees.value,
              employeesOther: formCopy.numberEmployees.value,
              howdid: formCopy.about?.value || 'Other',
              howdidOther: formCopy.hearabout?.value || '',
              token,
            }

            try {
              const res = await axios.post('/api/notifications/partnership', data)

              window.analytics.track(
                'User submitted b2b demo request',
                {
                  screenName: 'B2B onboarding funnel - Book a demo page',
                  isMobile: userAgentData.device.type === 'mobile',
                  browserName: userAgentData?.browser?.name ?? null,
                  browserVersion: userAgentData?.browser?.version ?? null,
                  osName: userAgentData?.os?.name ?? null,
                  osVersion: userAgentData?.os?.version ?? null,
                  deviceVendor: userAgentData?.device?.vendor ?? null,
                  deviceModel: userAgentData?.device?.model ?? null,
                  viewportHeight: viewportData.height,
                  viewportWidth: viewportData.width,
                  viewportOrientation: viewportData.orientation,
                  env: process.env.NODE_ENV === 'production' ? 'production' : 'development',
                  url: window?.location?.href,
                  path: window?.location?.pathname,
                  websitePage:
                    window.location.pathname.slice(-1) === '/'
                      ? window.location.pathname
                      : `${window.location.pathname}/`,
                },
                {
                  context: {
                    device: {
                      id: getDeviceId(),
                    },
                  },
                },
              )

              successMsg.classList.add('message-active')
              setTimeout(() => {
                successMsg.classList.remove('message-active')
              }, 8500)
              formCopy.reset()
            } catch (error) {
              console.log(error)
            }
          })
      })
    })
  }
}

export default PartnershipRenderer
